enum UserType {
  Admin = 'TrackingAppAdmin',
  SeniorCompanyManager = 'TrackingSeniorCompanyManager',
  BaseUser = 'TrackingAppUser',
}

export default UserType;
